import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import whatInput from 'what-input';
import SwiperCore, { A11y, Controller, EffectCoverflow, Keyboard } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
SwiperCore.use([A11y, Keyboard, Controller, EffectCoverflow]);
const Selector = (props) => {
    var _a, _b;
    const selectorRef = useRef(null);
    const menuRef = useRef(null);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        var _a, _b;
        if (open) {
            props.trackOpen ? props.trackOpen() : null;
            const menuHeight = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
            if (selectorRef.current && menuHeight > selectorRef.current.offsetHeight) {
                selectorRef.current.style.height = `${menuHeight}px`;
                selectorRef.current.style.visibility = 'visible';
            }
        }
        else {
            (_b = selectorRef.current) === null || _b === void 0 ? void 0 : _b.removeAttribute('style');
        }
    }, [open]);
    useEffect(() => {
        setOpen(props.open);
    }, [props.open, props.currentItem]);
    const swiperRef = useRef();
    /* methods */
    const slideMove = (swiper) => {
        const prev = document.getElementById(`selector-prev-${props.groupid}`);
        const next = document.getElementById(`selector-next-${props.groupid}`);
        if (swiper.isBeginning) {
            prev === null || prev === void 0 ? void 0 : prev.setAttribute('disabled', 'disabled');
            prev === null || prev === void 0 ? void 0 : prev.classList.add('swiper-button-disabled');
        }
        else {
            prev === null || prev === void 0 ? void 0 : prev.removeAttribute('disabled');
            prev === null || prev === void 0 ? void 0 : prev.classList.remove('swiper-button-disabled');
        }
        if (swiper.isEnd) {
            next === null || next === void 0 ? void 0 : next.setAttribute('disabled', 'disabled');
            next === null || next === void 0 ? void 0 : next.classList.add('swiper-button-disabled');
        }
        else {
            next === null || next === void 0 ? void 0 : next.removeAttribute('disabled');
            next === null || next === void 0 ? void 0 : next.classList.remove('swiper-button-disabled');
        }
    };
    /* config */
    const swiperConf = {
        a11y: {
            slideRole: null,
            slideLabelMessage: null,
        },
        // navigation: true,
        slidesPerView: (props.fullExpanded && 4) || 3.5,
        spaceBetween: 4,
        autoplay: false,
        slideToClickedSlide: false,
        breakpoints: {
            [window.mqObj.lg]: {
                slidesPerView: 6,
            },
            [window.mqObj.xxl]: {
                slidesPerView: 5,
                spaceBetween: 6,
            },
        },
        onSlideChange: slideMove,
        onInit: (swiper) => {
            slideMove(swiper);
        },
    };
    /* EFFECT */
    useLayoutEffect(() => {
        const prev = document.getElementById(`selector-prev-${props.groupid}`);
        const next = document.getElementById(`selector-next-${props.groupid}`);
        const prevHandler = (e) => {
            e.preventDefault();
            swiperRef.current.slidePrev();
        };
        const nextHandler = (e) => {
            e.preventDefault();
            swiperRef.current.slideNext();
        };
        prev === null || prev === void 0 ? void 0 : prev.addEventListener('click', prevHandler);
        next === null || next === void 0 ? void 0 : next.addEventListener('click', nextHandler);
        return () => {
            prev === null || prev === void 0 ? void 0 : prev.removeEventListener('click', prevHandler);
            next === null || next === void 0 ? void 0 : next.removeEventListener('click', nextHandler);
        };
    }, [props.open]);
    return (React.createElement("div", { className: classNames(props.className), ref: selectorRef, onMouseEnter: () => {
            whatInput.ask() === 'mouse' && !props.disableHover && props.children.length !== 1 && setOpen(true);
        }, onMouseLeave: () => {
            !props.disableHover && !props.open && props.children.length !== 1 && setOpen(false);
        } },
        React.createElement("div", { ref: menuRef, className: classNames('selector__menu'), id: props.selectorId, "aria-labelledby": props.selectorId + '-title', "aria-hidden": open ? null : true, tabIndex: -1 },
            (!(props === null || props === void 0 ? void 0 : props.hideLabel) || (props === null || props === void 0 ? void 0 : props.hideValue)) && (React.createElement("div", { className: "selector__menu-labels" },
                !(props === null || props === void 0 ? void 0 : props.hideLabel) && (React.createElement("span", { className: "selector__menu-label label", id: props.selectorId + '-title' }, (_a = props.selectLabel) !== null && _a !== void 0 ? _a : props.selectedLabel,
                    ":")),
                !(props === null || props === void 0 ? void 0 : props.hideValue) && React.createElement("span", { className: "selector__menu-value" }, props.itemType === 'string' ? props.currentItem : (_b = props.currentItem) === null || _b === void 0 ? void 0 : _b.displayValue))),
            open && (React.createElement("fieldset", null,
                React.createElement("legend", { className: "visually-hidden" }, props.unselectedLabel),
                React.createElement(SwiperInstance, Object.assign({ onSwiper: (swiper) => {
                        swiperRef.current = swiper;
                    } }, swiperConf), props.children[0].map((child, k) => (React.createElement(SwiperSlide, { key: k }, child)))))))));
};
Selector.defaultProps = {
    swatchable: false,
    enableOutofstockLabel: false,
    hideValue: false,
    itemType: 'object',
};
export default Selector;
